export var NUMBER_OF_COLUMNS_ON_MOBILE = 1;
export var NUMBER_OF_COLUMNS_ON_LARGE_DEVICES = 2;